import { createContext, useContext } from 'react';
import type { PayComCheckoutState } from './types';

export interface PayComContextValue {
  state: PayComCheckoutState;
  deleteSavedCard: (savedCardId: string) => Promise<void>;
}

export const PayComContext = createContext<PayComContextValue | undefined>(undefined);

export function usePayComContext(): PayComContextValue {
  const ctx = useContext(PayComContext);
  if (!ctx) throw new Error('usePayComContext must be used within a PayComProvider');
  return ctx;
}
